import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

interface RadioGroupOptionsType {
  [key: string]: any;
}

interface RadioGroupFieldProps {
  label?: string;
  meta: {
    touched: boolean;
    invalid: boolean;
    error: boolean;
  };
  input: { value: any; onChange: any };
  fullWidth: boolean;
  options: RadioGroupOptionsType[];
}

const RadioGroupField = ({
  fullWidth,
  input,
  label,
  options,
  meta: { touched, error },
  ...rest
}: RadioGroupFieldProps) => (
  <FormControl
    component="fieldset"
    fullWidth={fullWidth}
    error={touched && error}
  >
    <FormLabel component="legend">{label}</FormLabel>
    <RadioGroup {...input} {...rest}>
      {options.map(({ value, label }: RadioGroupOptionsType) => (
        <FormControlLabel
          key={value}
          value={value}
          control={<Radio />}
          label={label}
        />
      ))}
    </RadioGroup>
    <FormHelperText>{touched && error}</FormHelperText>
  </FormControl>
);

export default RadioGroupField;
